module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("89lgA"))).then(() => parcelRequire('d0iPb'));